import { useState } from "react";
import { login } from "../lib/api";

// Écran de connexion. Affiché tant que l'utilisateur n'est pas authentifié.
// L'inscription est fermée : les comptes sont créés en ligne de commande
// (script manage_users.py), donc pas de lien "créer un compte" ici.
export function Login({ onLoggedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await login(username.trim(), password);
      onLoggedIn(data);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        setError("Identifiants incorrects.");
      } else {
        setError("Impossible de se connecter au serveur.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: "#0a0a0c", padding: 20,
    }}>
      <div style={{
        width: "100%", maxWidth: 380, background: "#131317",
        border: "1px solid #27272a", borderRadius: 16, padding: 32,
        boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
      }}>
        {/* Logo / titre */}
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🎴</div>
          <h1 style={{
            fontSize: 24, fontWeight: 800, color: "#fff", margin: 0,
            letterSpacing: "-0.02em",
          }}>Bulbizarbi</h1>
          <p style={{ color: "#71717a", fontSize: 13, marginTop: 6 }}>
            Connecte-toi pour accéder à ta collection
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{
              display: "block", color: "#a1a1aa", fontSize: 12,
              fontWeight: 600, marginBottom: 6, textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}>Nom d'utilisateur</label>
            {/* autoCapitalize="none" est INDISPENSABLE : le clavier Android
                met une majuscule a la premiere lettre par defaut, « venus »
                partait donc en « Venus » et le backend, qui cherchait le nom
                a l'exact, repondait « Identifiants incorrects » — le meme
                message qu'un mauvais mot de passe, donc indebuggable a l'usage.
                autoCorrect/spellCheck evitent en plus qu'un nom d'utilisateur
                inconnu du dictionnaire soit « corrige » en autre chose. */}
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{
              display: "block", color: "#a1a1aa", fontSize: 12,
              fontWeight: 600, marginBottom: 6, textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}>Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              style={inputStyle}
            />
          </div>

          {error && (
            <div style={{
              background: "rgba(239,68,68,0.1)", border: "1px solid #ef4444",
              color: "#fca5a5", fontSize: 13, padding: "10px 12px",
              borderRadius: 8, marginBottom: 16,
            }}>{error}</div>
          )}

          <button
            type="submit"
            disabled={loading || !username || !password}
            style={{
              width: "100%", padding: "12px", borderRadius: 10, border: "none",
              background: loading || !username || !password ? "#3f3f46" : "#ef4444",
              color: "#fff", fontSize: 15, fontWeight: 700, cursor:
                loading || !username || !password ? "not-allowed" : "pointer",
              transition: "background 0.15s",
            }}
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}

const inputStyle = {
  width: "100%", padding: "10px 12px", borderRadius: 8,
  background: "#1c1c20", border: "1px solid #3f3f46", color: "#fff",
  fontSize: 14, outline: "none", boxSizing: "border-box",
};
